import React from 'react';
import {useTranslation} from "react-i18next";

function Loader({msg= ''}) {
    const {t} = useTranslation();

    return (
        <div className="loader-container">
            <img
                src="./images/loader/loader.gif"
                alt={`loader`}
                loading={"lazy"}
            />
            {msg && <div>{t(`server.${msg}`)}</div>}
        </div>
    );
}

export default Loader;
